import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { ContainerMain, BrandingTabContainer, BrandingTab } from '../common/commonStyles';
import SnapShot from './snapshot'
import { CommonFilterDropdown } from '../common/CommonYearFilter/CommonYearFilter';
const filterOption = ["Monthly", "Quarterly", "Yearly"];
const monthOption = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

const HealthDataManagement = ({ history, companyInfo }) => {
  let date = new Date();
  date.setFullYear(date.getFullYear() - 1);
  const [activeTab, setActiveTab] = useState(1);
  // const [selectedYear, setSelectedYear] = useState("2025");
  const [filterOptions, setFilterOptions] = useState(filterOption);
  const quarterlyOptions = ["Jan-Mar", "Apr-Jun", "Jul-Sep", "Oct-Dec"];
  const yearlyOptions = ["2025", "2024", "2023"];
  const [timeInterval, setTimeInterval] = useState('Monthly');
  const [filterOptionsName, setFilterOptionsName] = useState(monthOption);
  const [monthInterval, setMonthInterval] = useState(monthOption[new Date().getMonth()]);

  useEffect(()=>{
    if(history.location.state){
      setActiveTab(history.location.state.activeTab)
    }
  },[])

  useEffect(() => {
    switch (timeInterval) {
    case "Monthly":
      setFilterOptionsName(monthOption);
      break;
    case "Quarterly":
      setFilterOptionsName(quarterlyOptions);
      break;
    case "Yearly":
      setFilterOptionsName(yearlyOptions);
      break;
    default:
      setFilterOptionsName([]);
    }
  }, [timeInterval]);

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
    setFilterOptions(filterOption);
  };

  const getCurrentQuarter = () => {
    const month = new Date().getMonth(); // Get 1-based month (1 = Jan, 2 = Feb, ...)
    if (month >= 1 && month <= 3) return 0;
    if (month >= 4 && month <= 6) return 1;
    if (month >= 7 && month <= 9) return 2;
    return 3; // Months 10-12
  }

  const handleTimeIntervalChange = (selectedOption) => {
    const currentQuarter = getCurrentQuarter();
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    setTimeInterval(selectedOption);
    if (selectedOption === "Monthly") {
      setMonthInterval(monthOption[currentMonth]);
    } else if (selectedOption === "Quarterly") {
      setMonthInterval(quarterlyOptions?.[currentQuarter]);
    } else {
      setMonthInterval(currentYear);
    }
  };

  const handleMonthNameChange = (selectedOption) => {
    setMonthInterval(selectedOption)
  }

  let getColor = "rgba(243, 122, 101, 1)"

  const tabs = [
    { id: 1, label: 'Snapshot' }
  ];

  return (
    <> 
      <ContainerMain>
        <div className='content-wrap'>
          <BrandingTabContainer isCompare={"0px"}>
            <div className='wrapper'>
              {tabs.map((tab) => (
                <BrandingTab
                  key={tab.id}
                  onClick={() => handleTabClick(tab.id)}
                  active={activeTab === tab.id}
                  background={getColor ? getColor : "#0b4170"}
                >
                  {tab.label}
                </BrandingTab>
              ))}
            </div>
            <div className='rightSection'>
              <div>
                <CommonFilterDropdown
                  options={filterOptions}
                  selectedOption={timeInterval}
                  setSelectedOption={handleTimeIntervalChange}
                  dropdownHeight={"auto"}
                />
              </div>
              <div style={{marginLeft:"16px"}}>
                <CommonFilterDropdown
                  options={filterOptionsName}
                  selectedOption={monthInterval}
                  setSelectedOption={handleMonthNameChange}
                  dropdownHeight={"auto"}
                />
              </div>
            </div>
          </BrandingTabContainer>
          {activeTab==1&&<SnapShot companyId={companyInfo?.id} history={history}/>}
        </div>
      </ContainerMain>
    </>
  );
};

HealthDataManagement.propTypes = {
  companyInfo: PropTypes.object.isRequired,
  companyId: PropTypes.number,
  companyBrandingDetails: PropTypes.object,
  yearList: PropTypes.array,
  history:PropTypes.object
};

const mapStateToProps = (state) => ({
  companyBrandingDetails: state.wellnessDashboard.companyBrandingDetails
});

export default connect(mapStateToProps, null)(HealthDataManagement);